import {
  ChartableSurface,
  IChartedMultiStepTreatment,
  IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import { MockNamedDocument } from '@principle-theorem/testing';
import { ChartedMultiStepTreatment } from './charted-multi-step-treatment';
import { MockTreatment } from './charted-treatment.mock';
import { MockTreatmentStep } from './treatment-step.mock';

export function MockChartedMultiStepTreatment(
  data: Partial<IChartedMultiStepTreatment> = {}
): IChartedMultiStepTreatment {
  const staff = MockNamedDocument<IStaffer>();

  return ChartedMultiStepTreatment.init({
    config: MockNamedDocument(),
    scopeRef: { scope: ChartableSurface.WholeMouth },
    steps: [
      {
        ...MockTreatmentStep({ treatments: [MockTreatment()] }, [staff]),
        uid: 'step-1',
      },
    ],
    ...data,
  });
}
